import './DescriptionOrg.css';

/**
 * DescriptionOrg – shows event creator and (optionally) gathering organizer descriptions.
 *
 * Props:
 *   creator           – UserDto  (CommunityEvents creator, always required)
 *   creatorDescription – string  (CommunityEvents.Description)
 *   organizer          – UserDto | null  (Events.OrganizerId resolved; null when no gathering)
 *   organizerDescription – string | null  (Events.Description)
 *   onUserClick        – (userId) => void  (opens user details dialog)
 */
function DescriptionOrg({ creator, creatorDescription, organizer, organizerDescription, onUserClick }) {
  const showOrganizerRow = organizer && (organizer.id !== creator.id || organizerDescription);

  const renderUserName = (user, label) => (
    <span
      className={onUserClick ? 'desc-user-link' : 'desc-user-name'}
      onClick={onUserClick ? () => onUserClick(user.id) : undefined}
    >
      {label} {user.displayName || user.username}:
    </span>
  );

  return (
    <div className="description-org">
      <div className="desc-row">
        <div className="desc-col-label">
          {renderUserName(creator, 'Creator')}
        </div>
        <div className="desc-col-content">{creatorDescription}</div>
      </div>
      {showOrganizerRow && (
        <div className="desc-row">
          <div className="desc-col-label">
            {renderUserName(organizer, 'Organizer')}
          </div>
          <div className="desc-col-content">{organizerDescription || ''}</div>
        </div>
      )}
    </div>
  );
}

export default DescriptionOrg;